import React, { useState, useEffect, useRef } from 'react';
import DemoRequestModal from './DemoRequestModal';
import { submitDemoRequest } from '../utils/api';

function Cta() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);

  const handleSubmit = async (formData) => {
    try {
      await submitDemoRequest(formData); // Submit form data
      console.log('Demo request submitted successfully');
      // The modal will handle displaying the success message.
    } catch (error) {
      console.error('Error submitting demo request:', error.message);
      alert('Failed to submit demo request. Please try again.');
    }
  };

  return (
    <section id="cta">
      <div className="bg-[#000000] text-white py-16 mt-0">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Experience <span className="text-yellow-400">NIB ERP</span> in Action
          </h2>
          <p className="text-gray-200 mb-8 max-w-2xl mx-auto">
            Schedule a personalized demo and discover how our ERP can transform your business.
          </p>
          <button
            onClick={openModal}
            className="bg-yellow-400 text-[#0A0F1F] font-bold py-3 px-6 rounded-lg"
          >
            Request a Demo
          </button>
        </div>
      </div>

      <DemoRequestModal
        isOpen={isModalOpen}
        ref={modalRef}
        onClose={closeModal}
        onSubmit={handleSubmit}
      />
    </section>
  );
}

export default Cta;
